import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { loadUser } from "../../actions/auth";
import { LOGIN_SUCCESS,USER_PROPERTIES } from "../../actions/types";
import Logo from "../common/Logo";
import CheckToken from "./check_token";
import NotificationBell from "./NotificationBell";

const SideBar = () => {
  useTranslation();
  const history = useNavigate();
  const auth = useSelector((state) => state.auth);
  const user_properties = useSelector((state) => state.user_properties);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [workspaceOpen, setWorkspace] = useState(false);
  const [showmore, setShowMore] = useState(() => localStorage.getItem('sb-showmore') === '1');
  const [profileInfo, setProfileInfo] = useState([]);
  const [workspaceInfo, setWorkspaceInfo] = useState([]);
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('sb-collapsed') === '1');
  const [pendingWorkspace, setPendingWorkspace] = useState(null);
  const [switchingWorkspace, setSwitchingWorkspace] = useState(false);
  const linkClass = (extra = "") => ({ isActive }) => [isActive ? "active" : "", extra].filter(Boolean).join(" ");

  // Sync collapsed state with body class
  useEffect(() => {
    if (collapsed) {
      document.body.classList.add('sb-collapsed');
    } else {
      document.body.classList.remove('sb-collapsed');
    }
    localStorage.setItem('sb-collapsed', collapsed ? '1' : '0');
  }, [collapsed]);

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    document.addEventListener(
      "click",
      () => {
        setOpen(false);
        setWorkspace(false);
      },
      true
    );
    // Apply initial collapsed class
    if (localStorage.getItem('sb-collapsed') === '1') {
      document.body.classList.add('sb-collapsed');
    }
    getProfile();
    userCode();
    getWorkspaceInfo();
  }, []);

  useEffect(() => {
    if (!auth.avatar) return;
    setProfileInfo((prev) => ({ ...prev, avatar: auth.avatar }));
  }, [auth.avatar]);

  const isUrl = (value) => /^(?:https?|ftp):\/\//.test(value || "");

  const profileImageSrc = (avatar) => {
    if (!avatar) return "";
    if (isUrl(avatar)) return avatar;
    const cloudinaryBase = process.env.REACT_APP_CLOUDINARY_URL || "https://res.cloudinary.com/dg0lt9e0q/image/upload";
    return `${cloudinaryBase}${avatar.startsWith("/") ? "" : "/"}${avatar}`;
  };

  const userAvatar = (className) => {
    const src = profileImageSrc(profileInfo.avatar || auth.avatar);
    if (!src) return <div className={className}>{userCode()}</div>;
    return (
      <div className={`${className} ${className}--image`}>
        <img src={src} alt="" />
      </div>
    );
  };

  const getWorkspaceInfo = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post(
        "/api/workspace/listbyworkspaceid",
        body,
        config
      );
      if (res.status === 200) {
        setWorkspaceInfo(res.data.results);
        let i = 0;
        res.data.results.map((item)=> {
          if(item.id != auth.workspace_id) {
            i++;
          }
        })

        if(i === res.data.results.length) {
          selectWorkspace(res.data.results[0]);
        }
      }
    } catch (err) {
      console.log(err.response);
      if(err.response.status === 401 || err.response.status === 403) {
        console.log("loging out")
        history('/logout');
      }
      return err.response;
    }
  };
  
  const getProfile = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post("/api/profile/info", body, config);
      if (res.status === 200) {
        setProfileInfo(res.data.results[0][0]);
      }
    } catch (err) {
      if (err.response) {
        console.log(err.response);
        if(err.response.status === 401 || err.response.status === 403) {
          console.log("loging out")
          history('/logout');
        }
      }
    }
  };

  const userCode = () => {
    let firstLetter = "";
    let lastLeter = "";
    if (profileInfo.first_name !== null && profileInfo.last_name != null) {
      firstLetter = profileInfo.first_name.charAt(0);
      lastLeter = profileInfo.last_name.charAt(0);
    } else if (
      profileInfo.email !== null &&
      typeof profileInfo.email !== "undefined"
    ) {
      firstLetter = profileInfo.email.charAt(0);
      lastLeter = profileInfo.email.charAt(1);
    }
    return firstLetter.concat(lastLeter).toUpperCase();
  };

  const displayName = () => {
    if (profileInfo.first_name !== null && profileInfo.last_name != null) {
      let firstName = profileInfo.first_name;
      let lastName = profileInfo.last_name;
      return firstName.concat("  ").concat(lastName).toUpperCase();
    } else if (
      profileInfo.email !== null &&
      typeof profileInfo.email !== "undefined"
    ) {
      return profileInfo.email.split("@")[0].toUpperCase();
    }
  };

  const selectWorkspace = async (item) => {
    try {
      setSwitchingWorkspace(true);
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = item.id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post("/api/workspace/select", body, config);
      if (res.status === 200) {
        setPendingWorkspace(null);
        dispatch({ type: LOGIN_SUCCESS, payload: res.data });
        dispatch(loadUser(res.data));
        window.location.reload();
      }
    } catch (err) {
      setSwitchingWorkspace(false);
      if (err.response) {
        console.log(err.response);
        if(err.response.status === 401 || err.response.status === 403) {
          console.log("loging out")
          history('/logout');
      }
      }
    }
  };

  const requestWorkspaceSwitch = (item) => {
    if (!item || auth.workspace_id == item.id) {
      setWorkspace(false);
      return;
    }
    setWorkspace(false);
    setPendingWorkspace(item);
  };

  const closeWorkspaceConfirm = () => {
    if (switchingWorkspace) return;
    setPendingWorkspace(null);
  };

  const toggleCollapse = (e) => {
    e.stopPropagation();
    setCollapsed(c => !c);
  };

  return (
    <React.Fragment>
      <CheckToken />
      {/* Toggle tab — fixed position on right edge of sidebar, outside sidebar overflow */}
      <div className='sb-toggle-tab' onClick={toggleCollapse} title={collapsed ? tr("Expand sidebar") : tr("Collapse sidebar")}>
        <svg width='10' height='10' viewBox='0 0 10 10' fill='none'>
          <path
            d={collapsed ? 'M3 1l4 4-4 4' : 'M7 1L3 5l4 4'}
            stroke='rgba(255,255,255,0.7)'
            strokeWidth='1.8'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>
      <div className='sidebar sidebar-hide-to-small sidebar-shrink sidebar-gestures'>
        <div className='nano'>
          <div className='nano-content'>
            <div className='logo' id='logotoimage'>
              {/* Full wordmark — visible when expanded */}
              <a href='/' className='sb-full-logo'>
                <Logo />
              </a>
              {/* Mini logo — visible when collapsed */}
              <a href='/' className='sb-mini-logo'>
                <svg
                  viewBox='0 0 1000 600'
                  aria-label='Minutezilla'
                  role='img'
                >
                  <path
                    fill='#FFFFFF'
                    d='M662.06,194.99c-18.34,8.2-36.58,16.35-54.82,24.51c-1.93-1.79-2.85-3.93-4.01-5.88c-17.06-28.42-41.09-48.57-71.94-60.58c-13.17-5.13-26.84-7.96-40.94-9.06c-17.68-1.38-34.94,0.7-51.85,5.71c-19.25,5.71-36.47,15.18-51.69,28.34c-11.43,9.88-21.24,21.11-29,34.08c-3.87,6.47-7.61,13.03-10.14,20.18c-0.2,0.57-0.58,1.14-0.13,2.16c7.29,1.69,14.8,3.43,22.29,5.17c1.45-1.29,1.99-2.93,2.72-4.39c12.49-25.02,30.98-44.09,56.26-56.25c10.53-5.07,21.72-8.25,33.34-9.78c1.93-0.25,3.86-1.08,6.2-0.21c0.17,3.43,0.43,6.94,0.49,10.46c0.09,5.34,0.16,10.69,0.02,16.03c-0.15,5.67,3.85,8.93,8.52,9.52c2.62,0.33,5.22,0.21,7.75-0.74c3.79-1.41,5.76-3.99,5.8-8.06c0.08-7.96,0.06-15.93,0.1-23.89c0.01-1.03-0.19-2.1,0.36-3.29c2.27-0.82,4.65,0.03,6.93,0.35c21.94,3.05,41.31,11.9,58.28,26.1c11.98,10.02,21.31,22.15,28.92,35.69c1.18,2.09,2.35,4.19,3.75,6.68c36.27-15.97,71.86-33.16,108.01-49.07c0.63,1.04-0.19,1.29-0.57,1.66c-16.58,16.47-33.95,32.1-51.3,47.75c-16.18,14.59-32.72,28.77-49.07,43.17c-9.9,8.73-19.71,17.56-29.59,26.31c-13.96,12.36-27.97,24.66-41.93,37.03c-12.23,10.84-24.42,21.73-36.64,32.58c-2.51,2.22-5.14,4.31-7.6,6.58c-1.28,1.18-2.41,1.25-3.96,0.56c-9.58-4.24-19.2-8.38-28.79-12.58c-14.97-6.55-29.93-13.11-44.89-19.7c-13.52-5.96-27.01-11.96-40.52-17.93c-17.33-7.67-34.68-15.32-52-23.01c-7.66-3.4-15.25-6.94-22.95-10.25c-2.11-0.91-2.69-2.18-2.69-4.33c0.04-30.92-0.06-61.83,0.07-92.75c0.04-10.28,1.08-20.47,4.11-30.4c3.5-11.49,8.97-21.87,16.66-31.08c10.95-13.13,24.7-22.22,40.8-27.73c7.95-2.72,16.19-4.32,24.62-4.63c28.39-1.07,56.79-0.36,85.18-0.46c36.68-0.13,73.36-0.05,110.04-0.03c13.84,0.01,27.35,1.96,40.22,7.32c16.07,6.69,29.24,17.05,39.37,31.22c8.64,12.09,13.76,25.56,15.75,40.26c0.21,1.55,0.42,3.11,0.58,4.67C662.23,193.49,662.12,194.02,662.06,194.99z M562.73,245.28c-0.05-6.16-3.21-10.29-8.56-11.97c-3.5-1.11-6.6-0.12-9.63,1.5c-5.27,2.82-10.12,6.32-15.15,9.52c-11.13,7.08-22.19,14.27-33.23,21.48c-1.88,1.23-3.58,1.63-5.84,0.95c-4.29-1.29-8.73-1.23-13,0.14c-2,0.64-3.57,0.42-5.32-0.6c-13.41-7.75-26.85-15.46-40.3-23.14c-2.45-1.4-4.83-2.94-7.61-3.68c-6.17-1.64-12.01,1.39-13.76,7.18c-1.63,5.39,0.29,10.04,5.76,13.62c4.21,2.75,8.47,5.41,12.75,8.04c10.61,6.52,21.23,13.04,31.89,19.48c1.9,1.15,3.16,2.55,3.79,4.71c0.71,2.42,1.91,4.63,3.68,6.51c5.47,5.81,12.11,8.36,20.08,7.32c8.53-1.11,15.34-7.27,17.14-15.69c0.36-1.7,1.23-2.71,2.64-3.63c16.36-10.56,32.68-21.17,49.02-31.76C560.91,252.78,562.9,249.34,562.73,245.28z M336.2,283.15c0,3.46-0.02,6.92,0.01,10.37c0.03,3.22,0.62,3.85,3.91,3.82c5.86-0.05,11.71-0.51,17.58-0.39c2.6,0.05,3-0.42,3-3.23c-0.01-10.17,0.61-20.3,1.77-30.4c0.26-2.28-0.08-2.85-2.28-3.37c-5.71-1.34-11.47-2.46-17.29-3.19c-3.53-0.44-4.97,0.86-5.41,4.46C336.6,268.5,336.21,275.81,336.2,283.15z'
                  />
                  <path
                    fill='#FFFFFF'
                    d='M285.62,333.45c63.52,34.03,126.1,69.42,189.08,103.73c2.04-0.8,2.84-2.51,4.09-3.75c9.66-9.61,18.56-19.93,27.78-29.95c12.35-13.4,24.31-27.15,36.72-40.5c8.34-8.97,16.54-18.08,24.75-27.18c12.78-14.14,25.49-28.35,38.27-42.48c7.38-8.16,14.87-16.21,22.26-24.36c8.86-9.78,17.64-19.63,26.52-29.4c1.94-2.13,3.85-4.34,6.39-6.21c0.85,1.32,0.58,2.6,0.58,3.78c0.02,14.78,0,29.56-0.01,44.33c-0.01,35.42,0.03,70.85-0.06,106.27c-0.03,10.73-1.43,21.31-4.97,31.5c-7.88,22.71-22.39,39.71-43.77,50.84c-8.16,4.25-16.73,7.26-25.78,8.76c-5.67,0.94-11.39,1.67-17.17,1.67c-26.72,0-53.45,0.01-80.17,0.03c-25.47,0.02-50.93,0.08-76.4,0.09c-12.68,0-25.37,0.13-38.04-0.2c-20.78-0.53-39.79-6.53-56.29-19.5c-17.18-13.51-27.52-31.27-32.15-52.48c-1.34-6.15-1.95-12.41-2.01-18.71c-0.03-3.04-0.04-6.08-0.06-9.12c-0.11-13.72-0.22-27.45-0.33-41.17C284.81,337.59,284.82,335.71,285.62,333.45z'
                  />
                </svg>
              </a>
            </div>
            <ul className='main-sidebar-items'>
              <li>
                <NavLink to='/dashboard' className={linkClass()}>
                  <i>
                    <svg width='16' height='16' viewBox='0 0 18 18'>
                      <path
                        d='M8.001 8.948L8 9c0 .556.448 1 1 1h3c.556 0 1-.448 1-1 0-.556-.448-1-1-1h-2V4.003a1 1 0 10-2 0v4.894l.001.051zM9 18A9 9 0 109 0a9 9 0 000 18z'
                        fill='#ffffff'
                        fillRule='evenodd'
                      ></path>
                    </svg>
                  </i>{" "}{tr("Timer")} </NavLink>
              </li>
              <li>
                <NavLink to='/trace' className={linkClass()}>
                  <i>
                    <svg width='16' height='14' viewBox='0 0 24 21' fill='none' stroke='#ffffff' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
                      <circle cx='12' cy='10' r='8' />
                      <path d='M12 6v4.5l3 1.8' />
                    </svg>
                  </i>{tr("Trace")} <span className='sb-ai-badge' title={tr("AI-powered time tracking")}>{tr("AI")}</span>
                </NavLink>
              </li>
              <li className='label'>{tr("CORE / WORK")}</li>

              <li>
                <NavLink to='/calendar' className={linkClass()}>
                  <i>
                    <svg xmlns='http://www.w3.org/2000/svg' fill='#000000' width='16' height='16' viewBox='0 0 24 24'>
                      <path fill='#ffffff' fillRule='evenodd' d="M 5 0 L 5 4 L 7 4 L 7 0 Z M 17 0 L 17 4 L 19 4 L 19 0 Z M 1 3 C 0.449219 3 0 3.449219 0 4 L 0 7 C 0 7.550781 0.449219 8 1 8 L 1 24 L 23 24 L 23 8 C 23.550781 8 24 7.550781 24 7 L 24 4 C 24 3.449219 23.550781 3 23 3 L 20 3 L 20 5 L 16 5 L 16 3 L 8 3 L 8 5 L 4 5 L 4 3 Z M 3 8 L 21 8 L 21 22 L 3 22 Z M 5 10 L 5 12 L 7 12 L 7 10 Z M 9 10 L 9 12 L 11 12 L 11 10 Z M 13 10 L 13 12 L 15 12 L 15 10 Z M 17 10 L 17 12 L 19 12 L 19 10 Z M 5 14 L 5 16 L 7 16 L 7 14 Z M 9 14 L 9 16 L 11 16 L 11 14 Z M 13 14 L 13 16 L 15 16 L 15 14 Z M 17 14 L 17 16 L 19 16 L 19 14 Z M 5 18 L 5 20 L 7 20 L 7 18 Z M 9 18 L 9 20 L 11 20 L 11 18 Z M 13 18 L 13 20 L 15 20 L 15 18 Z M 17 18 L 17 20 L 19 20 L 19 18 Z"/>
                    </svg>
                  </i>{tr("Calendar")} </NavLink>
              </li>
              <li>
                <NavLink to='/reports' className={linkClass(auth.plan === 'free' ? 'sb-locked' : '')}>
                  <i>
                    <svg width='14' height='16' viewBox='0 0 14 16'>
                      <path
                        fill='#ffffff'
                        fillRule='evenodd'
                        d='M0 1.994A2 2 0 012.006 0h9.988C13.102 0 14 .895 14 1.994v12.012A2 2 0 0111.994 16H2.006A2.001 2.001 0 010 14.006V1.994zM2 3c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C2.455 2 2 2.448 2 3zm0 3c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C2.455 5 2 5.448 2 6zm0 3c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C2.455 8 2 8.448 2 9z'
                      ></path>
                    </svg>
                  </i>{tr("Reports")} {auth.plan === 'free' && <span className='sb-lock-badge'>{tr("Pro")}</span>}
                </NavLink>
              </li>
              <li>
                <NavLink to='/insights' className={linkClass(auth.plan === 'free' ? 'sb-locked' : '')}>
                  <i>
                    <svg width='16' height='12' viewBox='0 0 16 12'>
                      <path
                        d='M0 2.009C0 .899.895 0 1.994 0h12.012C15.107 0 16 .902 16 2.009V9.99c0 1.11-.895 2.009-1.994 2.009H1.994A2.003 2.003 0 010 9.991V2.01zm6.106 8.438c.415.83 1.639.696 1.864-.204l1.25-5 .852 2.128a1 1 0 001.635.336l2-2a1 1 0 10-1.414-1.414l-.928.928-1.437-3.592c-.36-.901-1.663-.813-1.898.128L6.685 7.135l-.79-1.582a1 1 0 00-1.602-.26l-2 2a1 1 0 101.414 1.414l1.019-1.019 1.38 2.76z'
                        fill='#ffffff'
                        fillRule='evenodd'
                      ></path>
                    </svg>
                  </i>{tr("Insights")} {auth.plan === 'free' && <span className='sb-lock-badge'>{tr("Pro")}</span>}
                </NavLink>
              </li>

              <li className='label'>{tr("MANAGEMENT")}</li>

              <li>
                <NavLink to='/projects' className={linkClass()}>
                  <i>
                    <svg width='16' height='13' viewBox='0 0 16 13'>
                      <path
                        fill='#ffffff'
                        fillRule='evenodd'
                        d='M0 6h16v4.994A2.001 2.001 0 0114.006 13H1.994A1.993 1.993 0 010 10.994V6zm0-4a2 2 0 012.004-2h3.05c1.107 0 2.004.895 2.004 2h6.935C15.102 2 16 2.895 16 4H0V2z'
                      ></path>
                    </svg>
                  </i>{tr("Projects")} </NavLink>
              </li>
              <li>
                <NavLink to='/clients' className={linkClass()}>
                  <i>
                    <svg width='18' height='18' viewBox='0 0 16 18'>
                      <path
                        d='M0 2.993A2.994 2.994 0 013.01 0h9.98C14.654 0 16 1.353 16 2.993v12.014A2.994 2.994 0 0112.99 18H3.01C1.346 18 0 16.647 0 15.007V2.993zM6.5 9.5c0 1.5-3.5 1-3.5 4 0 1 0 0 0 0A1.5 1.5 0 004.497 15h7.006C12.33 15 13 14.323 13 13.5c0 0 0 1 0 0 0-3-3.5-2.5-3.5-4C9.5 8.5 11 8 11 6c0-1.5-1.343-3-3-3S5 4.5 5 6c0 2 1.5 2.5 1.5 3.5z'
                        fill='#ffffff'
                        fillRule='evenodd'
                      ></path>
                    </svg>
                  </i>{" "}{tr("Clients")} </NavLink>
              </li>
              <li>
                <NavLink to='/team' className={linkClass()}>
                  <i>
                    <svg width='18' height='14' viewBox='0 0 18 14'>
                      <path
                        fill='#ffffff'
                        fillRule='evenodd'
                        d='M11.572 8.295C11.282 7.678 10.5 7 10.5 6c0-1.5.5-3 2.5-3s2.5 1.5 2.5 3-1 1.5-1 3c0 2 3.5.5 3.5 3v.5c0 .821-.67 1.5-1.499 1.5H12v-2.072c0-1.683 0-2.72-.428-3.633zM4 7c0-1-1.5-1.5-1.5-3.5C2.5 2 3 0 5.5 0s3 2 3 3.5C8.5 5.5 7 6 7 7c0 2.5 4 1 4 5v.5c0 .821-.674 1.5-1.506 1.5H1.506A1.502 1.502 0 010 12.5V12c0-4 4-2.5 4-5z'
                      ></path>
                    </svg>
                  </i>{tr("Team")} </NavLink>
              </li>
              <li>
                <NavLink to='/tag' className={linkClass()}>
                  <i>
                    <svg width='15' height='15' viewBox='0 0 15 15'>
                      <path
                        fill='#ffffff'
                        fillRule='evenodd'
                        d='M0 4.994V2.006C0 .886.898 0 2.006 0h2.988c1.12 0 2.638.632 3.418 1.412l5.176 5.176a1.996 1.996 0 01-.005 2.829l-4.166 4.166a2 2 0 01-2.829.005L1.412 8.412C.628 7.628 0 6.102 0 4.994zM4 6a2 2 0 100-4 2 2 0 000 4z'
                      ></path>
                    </svg>
                  </i>{" "}{tr("Tags")} </NavLink>
              </li>

              {auth.team_size !== 'solo' && (
                <>
                  <li className='label'>{tr("HR / COMPLIANCE")}</li>

                  <li>
                    <NavLink to='/leave' className={linkClass(!auth.hr_enabled ? 'sb-locked' : '')}>
                      <i>
                        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#ffffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                          <path d='M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z'/>
                          <polyline points='9 22 9 12 15 12 15 22'/>
                        </svg>
                      </i>{tr("Leave")} {!auth.hr_enabled && <span className='sb-lock-badge'>{tr("Pro")}</span>}
                    </NavLink>
                  </li>

                  {(auth.is_workspace_admin === 1 || auth.workspace_role === 'ADMIN' || auth.workspace_role === 'MANAGER') && (
                    <>
                      <li>
                        <NavLink to='/attendance' className={linkClass(!auth.hr_enabled ? 'sb-locked' : '')}>
                          <i>
                            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#ffffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                              <rect x='3' y='4' width='18' height='18' rx='2' ry='2'/>
                              <line x1='16' y1='2' x2='16' y2='6'/>
                              <line x1='8' y1='2' x2='8' y2='6'/>
                              <line x1='3' y1='10' x2='21' y2='10'/>
                              <polyline points='9 16 11 18 15 14'/>
                            </svg>
                          </i>{tr("Attendance")} {!auth.hr_enabled && <span className='sb-lock-badge'>{tr("Pro")}</span>}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to='/compliance' className={linkClass(!auth.hr_enabled ? 'sb-locked' : '')}>
                          <i>
                            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#ffffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                              <path d='M12 2l8 4v6c0 5-3.5 9.7-8 10-4.5-.3-8-5-8-10V6l8-4z'/>
                              <path d='M9 12l2 2 4-4'/>
                            </svg>
                          </i>{tr("Compliance")} {!auth.hr_enabled && <span className='sb-lock-badge'>{tr("Pro")}</span>}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to='/hr-reports' className={linkClass(!auth.hr_enabled ? 'sb-locked' : '')}>
                          <i>
                            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#ffffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                              <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'/>
                              <circle cx='9' cy='7' r='4'/>
                              <path d='M23 21v-2a4 4 0 0 0-3-3.87'/>
                              <path d='M16 3.13a4 4 0 0 1 0 7.75'/>
                            </svg>
                          </i>{tr("HR Reports")} {!auth.hr_enabled && <span className='sb-lock-badge'>{tr("Pro")}</span>}
                        </NavLink>
                      </li>
                    </>
                  )}
                </>
              )}

              <li className='label'>{tr("FINANCE")}</li>

              {(auth.is_workspace_admin === 1 || auth.workspace_role === 'ADMIN' || auth.workspace_role === 'MANAGER') && (
                <li>
                  <NavLink to='/invoices' className={linkClass(!auth.hr_enabled ? 'sb-locked' : '')}>
                    <i>
                      <svg width='16' height='18' viewBox='0 0 16 18'>
                        <path fill='#ffffff' fillRule='evenodd' d='M3 0h6.586a2 2 0 011.414.586l3.414 3.414A2 2 0 0116 5.414V15.5A2.5 2.5 0 0113.5 18h-11A2.5 2.5 0 010 15.5v-13A2.5 2.5 0 012.5 0H3zm7 2.414V5a1 1 0 001 1h2.586L10 2.414zM4 8a1 1 0 100 2h8a1 1 0 100-2H4zm0 4a1 1 0 100 2h8a1 1 0 100-2H4z'></path>
                      </svg>
                    </i>{tr("Invoices")} {!auth.hr_enabled && <span className='sb-lock-badge'>{tr("Pro")}</span>}
                  </NavLink>
                </li>
              )}
              <li>
                <Link to='/import'>
                  <i>
                    <svg width='16' height='17' viewBox='0 0 16 17'>
                      <path
                        fill='#ffffff'
                        fillRule='evenodd'
                        d='M9 13v-2H7v2H5.99c-.539 0-.721.358-.39.8l1.8 2.4c.334.445.869.442 1.2 0l1.8-2.4c.334-.445.156-.8-.39-.8H9zM7 9v2h2V9h1.01c.546 0 .724-.355.39-.8L8.6 5.8c-.331-.442-.866-.445-1.2 0L5.6 8.2c-.331.442-.149.8.39.8H7zm5-4.965a3.5 3.5 0 110 6.93V11H3.5A3.5 3.5 0 114 4.035V4a4 4 0 118 .035z'
                      ></path>
                    </svg>
                  </i>
                  <span className='remove-text'>{tr("Import/Export")}</span>
                </Link>
              </li>
              <li>
                <Link to='/subscription'>
                  <i>
                    <svg width='16' height='12' viewBox='0 0 16 12'>
                      <path
                        fill='#ffffff'
                        fillRule='evenodd'
                        d='M0 2.009C0 .899.895 0 1.994 0h12.012C15.107 0 16 .902 16 2.009V9.99c0 1.11-.895 2.009-1.994 2.009H1.994A2.003 2.003 0 010 9.991V2.01zM0 3v3h16V3H0z'
                      ></path>
                    </svg>
                  </i>
                  <span className='remove-text'>{tr("Subscription")}</span>
                </Link>
              </li>

              <li className='label'>{tr("HELP / RESOURCES")}</li>
              <li>
                <NavLink to='/help' className={linkClass()}>
                  <i>
                    <svg width='16' height='16' viewBox='0 0 16 16'>
                      <path
                        fill='#ffffff'
                        fillRule='evenodd'
                        d='M8 16A8 8 0 118 0a8 8 0 010 16zm0-3a1 1 0 100-2 1 1 0 000 2zm0-8c.683 0 1.068.57.955 1.1-.077.362-.2.53-.623.908l-.052.046c-.83.741-1.202 1.316-1.278 2.416a1 1 0 101.996.138c.032-.476.135-.634.613-1.061l.053-.048c.711-.634 1.062-1.113 1.247-1.982A2.914 2.914 0 008 3c-1.572 0-2.501.84-3.057 2.145a1 1 0 001.84.784C7.057 5.285 7.373 5 8 5z'
                      ></path>
                    </svg>
                  </i>{tr("Help")} </NavLink>
              </li>

              {!showmore && (
                <li className='show-more-btn'>
                  <a className='sidebar-sub-toggle'
                    onClick={() => {
                        setShowMore(true);
                        localStorage.setItem('sb-showmore', '1');
                        setWorkspace(false);
                        setOpen(false);
                      }}>
                    <i>
                      <svg width='14' height='8' viewBox='0 0 14 8'>
                        <path
                          fill='none'
                          stroke='#ffffff'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M1 1l6 6 6-6'
                        ></path>
                      </svg>
                    </i>
                    <span className='show-more-menus'>{tr("Show More")}</span>
                  </a>
                </li>
              )}

              {showmore && (
                <>
                  <li>
                    <Link to='/training'>
                      <i>
                        <svg width='10' height='10' viewBox='0 0 10 10'>
                          <g
                            fill='none'
                            fillRule='evenodd'
                            stroke='#ffffff'
                            strokeLinecap='round'
                            strokeWidth='2'
                          >
                            <path d='M.5 9.5L9.011.989'></path>
                            <path strokeLinejoin='round' d='M2 1h7v7'></path>
                          </g>
                        </svg>
                      </i>{" "}
                      <span className='remove-text'>{tr("Training")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to='/mobile-app'>
                      <i>
                        <svg width='12' height='18' viewBox='0 0 12 18'>
                          <path
                            fill='#ffffff'
                            d='M2 4v9a1 1 0 001 1h6a1 1 0 001-1V4a1 1 0 00-1-1H3a1 1 0 00-1 1zm0-4h8a2 2 0 012 2v14a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z'
                          ></path>
                        </svg>
                      </i>{" "}
                      <span className='remove-text'>{tr("Mobile App")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to='/blog'>
                      <i>
                        <svg width='10' height='10' viewBox='0 0 10 10'>
                          <g
                            fill='none'
                            fillRule='evenodd'
                            stroke='#ffffff'
                            strokeLinecap='round'
                            strokeWidth='2'
                          >
                            <path d='M.5 9.5L9.011.989'></path>
                            <path strokeLinejoin='round' d='M2 1h7v7'></path>
                          </g>
                        </svg>
                      </i>
                      <span className='remove-text'>{tr("Blog")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to='/jobs'>
                      <i>
                        <svg width='10' height='10' viewBox='0 0 10 10'>
                          <g
                            fill='none'
                            fillRule='evenodd'
                            stroke='#ffffff'
                            strokeLinecap='round'
                            strokeWidth='2'
                          >
                            <path d='M.5 9.5L9.011.989'></path>
                            <path strokeLinejoin='round' d='M2 1h7v7'></path>
                          </g>
                        </svg>
                      </i>
                      <span className='remove-text'> {tr("Jobs")}</span>
                    </Link>
                  </li>
                  <li className='show-more-btn'>
                    <a className='sidebar-sub-toggle'
                      onClick={() => {
                          setShowMore(false);
                          localStorage.setItem('sb-showmore', '0');
                          setWorkspace(false);
                          setOpen(false);
                        }}>
                      <i style={{ transform: 'rotate(180deg)' }}>
                        <svg width='14' height='8' viewBox='0 0 14 8'>
                          <path
                            fill='none'
                            stroke='#ffffff'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M1 1l6 6 6-6'
                          ></path>
                        </svg>
                      </i>
                      <span className='show-more-menus'>{tr("Show Less")}</span>
                    </a>
                  </li>
                </>
              )}

              <li className='label'>{tr("SETTINGS")}</li>
              <li><NavLink to='/integrations' className={linkClass()}><i><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 007 .5l3-3a5 5 0 00-7-7l-2 2"/><path d="M14 11a5 5 0 00-7-.5l-3 3a5 5 0 007 7l2-2"/></svg></i>{tr("Integrations")}</NavLink></li>
              <li>
                <NavLink to='/settings' className={linkClass()}>
                  <i>
                    <svg width='16' height='16' viewBox='0 0 16 16'>
                      <path
                        d='M8 11a3 3 0 100-6 3 3 0 000 6zM5.182 2.702c.337-.18.693-.328 1.065-.442L6.778.666C6.9.299 7.313 0 7.7 0h.6c.387 0 .8.298.922.666l.531 1.594c.372.114.728.262 1.065.442l1.504-.752c.346-.173.85-.093 1.122.18l.425.426c.274.273.354.775.181 1.122l-.752 1.504c.18.337.328.693.442 1.065l1.594.531c.367.122.666.535.666.922v.6c0 .387-.298.8-.666.922l-1.594.531a5.963 5.963 0 01-.442 1.065l.752 1.504c.173.346.093.85-.18 1.122l-.426.425c-.273.274-.775.354-1.122.181l-1.504-.752c-.337.18-.693.328-1.065.442l-.531 1.594C9.1 15.701 8.687 16 8.3 16h-.6c-.388 0-.8-.298-.922-.666l-.531-1.594a5.963 5.963 0 01-1.065-.442l-1.504.752c-.346.173-.85.093-1.122-.18l-.425-.426c-.274-.273-.354-.775-.181-1.122l.752-1.504a5.963 5.963 0 01-.442-1.065L.666 9.222C.299 9.1 0 8.687 0 8.3v-.6c0-.388.298-.8.666-.922l1.594-.531c.114-.372.262-.728.442-1.065L1.95 3.678c-.173-.346-.093-.85.18-1.122l.426-.425c.273-.274.775-.354 1.122-.181l1.504.752z'
                        fill='#ffffff'
                        fillRule='evenodd'
                      ></path>
                    </svg>
                  </i>{tr("Settings")} </NavLink>
              </li>
            </ul>
            <ul className='user-workspace-container'>
              {/* Notification bell */}
              <NotificationBell />

              <div className='sb-section-divider' />

              {/* Workspace selector */}
              <div
                className='sb-workspace-row'
                data-tour='sidebar-workspace-switcher'
                onClick={() => { setWorkspace(!workspaceOpen); setOpen(false); }}
              >
                <div className='sb-ws-icon'>
                  <svg width='14' height='14' viewBox='0 0 18 16' fill='none'>
                    <path d='M6.503 2h4.994c.098 0 .252.119.275.21l.758 3.033L13.5 4h-9l.97 1.243.758-3.032c.024-.094.173-.211.275-.211zm7.778 2l-.569-2.274C13.466.74 12.51 0 11.497 0H6.503c-1.02 0-1.97.743-2.215 1.726L3.719 4H1.995C.893 4 0 4.9 0 6.009v7.982C0 15.098.893 16 1.995 16h14.01C17.107 16 18 15.1 18 13.991V6.01A2.004 2.004 0 0016.005 4H14.28z' fill='#4bc800'/>
                  </svg>
                </div>
                <span className='sb-ws-name'>{profileInfo.title || tr("Workspace")}</span>
                <svg className='sb-ws-chevron' width='12' height='12' viewBox='0 0 12 12' fill='none'>
                  <path d='M3 4.5l3 3 3-3' stroke='rgba(255,255,255,0.4)' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>

              <div className='sb-section-divider' />

              {/* Profile */}
              <div
                className='sb-profile-area'
                onClick={() => { setOpen(!open); setWorkspace(false); }}
              >
                {userAvatar('sb-avatar')}
                <div className='sb-profile-text'>
                  <div className='sb-profile-name'>{displayName()}</div>
                  <div className='sb-profile-email'>{profileInfo.email}</div>
                </div>
                <svg className='sb-profile-chevron' width='12' height='12' viewBox='0 0 12 12' fill='none'>
                  <path d='M4.5 3l3 3-3 3' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
            </ul>
          </div>
        </div>
      </div>
      {/* ── Workspace switcher panel ── */}
      <div
        className='sb-panel sb-panel--workspace'
        id='popup1'
        style={{ display: workspaceOpen ? "" : "none", zIndex: 1000 }}
      >
        {/* Header */}
        <div className='sb-panel__header'>
          <span className='sb-panel__title'>{tr("Switch Workspace")}</span>
          <svg width='14' height='14' viewBox='0 0 18 16' fill='none'>
            <path d='M6.503 2h4.994c.098 0 .252.119.275.21l.758 3.033L13.5 4h-9l.97 1.243.758-3.032c.024-.094.173-.211.275-.211zm7.778 2l-.569-2.274C13.466.74 12.51 0 11.497 0H6.503c-1.02 0-1.97.743-2.215 1.726L3.719 4H1.995C.893 4 0 4.9 0 6.009v7.982C0 15.098.893 16 1.995 16h14.01C17.107 16 18 15.1 18 13.991V6.01A2.004 2.004 0 0016.005 4H14.28z' fill='#4bc800'/>
          </svg>
        </div>

        {/* Workspace list */}
        <div className='sb-panel__list'>
          {workspaceInfo.map((item, index) => {
            const isActive = auth.workspace_id == item.id;
            const initials = (item.title || item.workspace_title || 'W')
              .split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
            return (
              <div
                key={index}
                className={`sb-ws-item${isActive ? ' sb-ws-item--active' : ''}`}
                onClick={() => requestWorkspaceSwitch(item)}
              >
                <div className={`sb-ws-item__avatar${isActive ? ' sb-ws-item__avatar--active' : ''}`}>
                  {initials}
                </div>
                <span className='sb-ws-item__name'>{item.title || item.workspace_title}</span>
                {isActive && (
                  <svg className='sb-ws-item__check' width='14' height='14' viewBox='0 0 14 14' fill='none'>
                    <circle cx='7' cy='7' r='7' fill='#4bc800' fillOpacity='0.15'/>
                    <path d='M4 7l2.5 2.5L10 4.5' stroke='#4bc800' strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                )}
              </div>
            );
          })}
        </div>

        {/* Footer actions */}
        <div className='sb-panel__footer'>
          <Link to='/workspaces' className='sb-panel__action'>
            <svg width='14' height='14' viewBox='0 0 16 16' fill='none'>
              <path d='M8 1v6M1 8h6M8 15V9M15 8H9' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round'/>
              <circle cx='8' cy='8' r='7' stroke='currentColor' strokeWidth='1.4'/>
            </svg>{tr("Manage Workspaces")} </Link>
          <Link to='/workspace' className='sb-panel__action sb-panel__action--create'>
            <svg width='14' height='14' viewBox='0 0 14 14' fill='none'>
              <path d='M7 1v12M1 7h12' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round'/>
            </svg>{tr("New Workspace")} </Link>
        </div>
      </div>

      {/* ── Profile panel ── */}
      <div
        className='sb-panel sb-panel--profile'
        id='tooltip'
        style={{ display: open ? "" : "none", zIndex: 1000 }}
      >
        {/* User identity */}
        <div className='sb-panel__identity'>
          {userAvatar('sb-panel__id-avatar')}
          <div className='sb-panel__id-info'>
            <span className='sb-panel__id-name'>{displayName()}</span>
            <span className='sb-panel__id-email'>{profileInfo.email}</span>
          </div>
        </div>

        {/* Nav links */}
        <div className='sb-panel__nav'>
          <Link to='/profile' className='sb-panel__nav-item'>
            <svg width='15' height='15' viewBox='0 0 16 16' fill='none'>
              <circle cx='8' cy='5' r='3' stroke='currentColor' strokeWidth='1.5'/>
              <path d='M2 14c0-3.314 2.686-6 6-6s6 2.686 6 6' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round'/>
            </svg>{tr("Profile Settings")} </Link>
          <Link to='/settings' className='sb-panel__nav-item'>
            <svg width='15' height='15' viewBox='0 0 16 16' fill='none'>
              <path d='M8 10a2 2 0 100-4 2 2 0 000 4z' stroke='currentColor' strokeWidth='1.4'/>
              <path d='M13.3 7.1l.9-.3V7v2l-.9-.3a5.4 5.4 0 01-.5.9l.4.8-1.4 1.4-.8-.4a5.4 5.4 0 01-.9.5l-.3.9H8.1l-.3-.9a5.4 5.4 0 01-.9-.5l-.8.4-1.4-1.4.4-.8a5.4 5.4 0 01-.5-.9L4 9V7l.6.2a5.4 5.4 0 01.5-.9l-.4-.8 1.4-1.4.8.4a5.4 5.4 0 01.9-.5L7.9 4h.2l.9.3' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round'/>
            </svg>{tr("Workspace Settings")} </Link>
          <Link to='/integrations' className='sb-panel__nav-item'><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 007 .5l3-3a5 5 0 00-7-7l-2 2"/><path d="M14 11a5 5 0 00-7-.5l-3 3a5 5 0 007 7l2-2"/></svg>{tr("Integrations")}</Link>
          <Link to='/achievements' className='sb-panel__nav-item'>
            <svg width='15' height='15' viewBox='0 0 16 16' fill='none'>
              <path d='M8 1l1.8 3.6L14 5.4l-3 2.9.7 4.1L8 10.4 4.3 12.4l.7-4.1L2 5.4l4.2-.8L8 1z' stroke='currentColor' strokeWidth='1.4' strokeLinejoin='round'/>
            </svg>{tr("Achievements")} </Link>
        </div>

        {/* Logout */}
        <div className='sb-panel__logout'>
          <Link to='/logout' className='sb-panel__logout-btn'>
            <svg width='15' height='15' viewBox='0 0 16 16' fill='none'>
              <path d='M10 2h3a1 1 0 011 1v10a1 1 0 01-1 1h-3M7 11l4-4-4-4M11 8H1' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>{tr("Log Out")} </Link>
        </div>
      </div>

      <Modal
        show={!!pendingWorkspace}
        onHide={closeWorkspaceConfirm}
        centered
        backdrop={switchingWorkspace ? 'static' : true}
        keyboard={!switchingWorkspace}
        dialogClassName='add-New-tag-popup-box-container'
      >
        <div className='modal-content'>
          <div className='pm-header'>
            <h3 className='pm-title'>{tr("Switch Workspace?")}</h3>
          </div>
          <div style={{ padding: '20px 22px 10px', color: '#4b5563', fontSize: '14px', lineHeight: '1.6' }}>
            <p style={{ margin: 0 }}>{tr("You are about to switch to")} <strong>{pendingWorkspace?.title || pendingWorkspace?.workspace_title}</strong>{tr(". The app context will change, so projects, clients, team members, and reports may look different.")} </p>
          </div>
          <div className='pm-footer'>
            <button className='pm-btn-cancel' onClick={closeWorkspaceConfirm} disabled={switchingWorkspace}>{tr("Cancel")} </button>
            <button
              className='pm-btn-create'
              onClick={() => pendingWorkspace && selectWorkspace(pendingWorkspace)}
              disabled={switchingWorkspace}
            >
              {switchingWorkspace ? tr("Switching...") : tr("Switch Workspace")}
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default SideBar;
